
export default {
  name: "BoxPhotoExample",
  data() {
    return {
      name: '',
    }
  }
}
